import React, { useEffect } from 'react';
import { AdvisorySection } from '../components/AdvisorySection';
export function AdvisoryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-248">
      <AdvisorySection data-id="element-249" />
    </div>;
}